document.addEventListener('DOMContentLoaded', function () {

  /* ---------------------------------------------------------------------
     Age verification gate
     ------------------------------------------------------------------- */
  var gate = document.querySelector('[data-age-gate]');
  if (gate) {
    var storageKey = gate.getAttribute('data-storage-key') || 'sm_age_verified';

    function getCookie(name) {
      var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : null;
    }
    function setCookie(name, value, days) {
      var expires = new Date(Date.now() + days * 864e5).toUTCString();
      document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
    }
    function markVerified() {
      try { window.localStorage.setItem(storageKey, 'yes'); } catch (e) {}
      setCookie(storageKey, 'yes', 365);
    }
    function isVerified() {
      var fromStorage = false;
      try { fromStorage = window.localStorage.getItem(storageKey) === 'yes'; } catch (e) {}
      return fromStorage || getCookie(storageKey) === 'yes';
    }

    if (isVerified()) {
      gate.setAttribute('hidden', '');
    } else {
      gate.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';

      var confirmBtn = gate.querySelector('[data-age-confirm]');
      var declineBtn = gate.querySelector('[data-age-decline]');
      var errorEl = gate.querySelector('[data-age-error]');
      var declineUrl = gate.getAttribute('data-decline-url') || 'https://www.sst.dk';

      confirmBtn && confirmBtn.addEventListener('click', function () {
        markVerified();
        gate.setAttribute('hidden', '');
        document.body.style.overflow = '';
      });

      declineBtn && declineBtn.addEventListener('click', function () {
        if (errorEl) errorEl.setAttribute('data-visible', 'true');
        window.location.href = declineUrl;
      });
    }
  }


    /* ---------------------------------------------------------------------
     Product page: gallery thumbnails
     ------------------------------------------------------------------- */
  var mainImage = document.getElementById('PdpMainImage');
  var thumbs = document.querySelectorAll('[data-pdp-thumb]');
  if (mainImage && thumbs.length) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        mainImage.src = thumb.getAttribute('data-full');
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

    /* ---------------------------------------------------------------------
     Product page: variant option controls (selects + swatches) update
     hidden variant id, price, and image
     ------------------------------------------------------------------- */
  var variantScript = document.querySelector('[data-pdp-variants]');
  var optionGroups = document.querySelectorAll('[data-pdp-option-index]');
  if (variantScript && optionGroups.length) {
    var variants = [];
    try { variants = JSON.parse(variantScript.textContent); } catch (e) {}

    var currentValues = [];
    optionGroups.forEach(function (group) {
      var index = parseInt(group.getAttribute('data-pdp-option-index'), 10);
      if (group.tagName === 'SELECT') {
        currentValues[index] = group.value;
      } else {
        var activeSwatch = group.querySelector('[data-pdp-swatch].is-active');
        currentValues[index] = activeSwatch ? activeSwatch.getAttribute('data-swatch-value') : null;
      }
    });

    function findVariant(values) {
      return variants.filter(function (v) {
        return v.options.every(function (opt, i) { return opt === values[i]; });
      })[0];
    }

    function formatMoney(cents) {
      return (cents / 100).toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kr.';
    }

    function applyVariant(match) {
      if (!match) return;

      var idInput = document.querySelector('[data-pdp-variant-id]');
      if (idInput) idInput.value = match.id;

      var priceEl = document.querySelector('[data-pdp-price]');
      if (priceEl) priceEl.textContent = formatMoney(match.price);

      var compareEl = document.querySelector('[data-pdp-compare-price]');
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = formatMoney(match.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      var addBtn = document.querySelector('[data-pdp-add-btn]');
      if (addBtn) addBtn.disabled = !match.available;

      if (match.featured_image && mainImage) {
        mainImage.src = match.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_1000x$1$2');
      }
    }

    optionGroups.forEach(function (group) {
      var index = parseInt(group.getAttribute('data-pdp-option-index'), 10);

      if (group.tagName === 'SELECT') {
        group.addEventListener('change', function () {
          currentValues[index] = group.value;
          applyVariant(findVariant(currentValues));
        });
      } else {
        group.querySelectorAll('[data-pdp-swatch]').forEach(function (swatch) {
          swatch.addEventListener('click', function () {
            group.querySelectorAll('[data-pdp-swatch]').forEach(function (s) { s.classList.remove('is-active'); });
            swatch.classList.add('is-active');
            currentValues[index] = swatch.getAttribute('data-swatch-value');
            applyVariant(findVariant(currentValues));
          });
        });
      }
    });
  }

  /* ---------------------------------------------------------------------
     Product page: sticky add-to-cart bar
     ------------------------------------------------------------------- */
  var stickyBar = document.querySelector('[data-pdp-sticky-bar]');
  var pdpAddBtn = document.querySelector('[data-pdp-add-btn]');
  if (stickyBar && pdpAddBtn) {
    stickyBar.removeAttribute('hidden');

    var stickyAddBtn = stickyBar.querySelector('[data-pdp-sticky-add]');
    stickyAddBtn && stickyAddBtn.addEventListener('click', function () {
      var form = document.getElementById('PdpForm');
      if (form && form.requestSubmit) form.requestSubmit();
      else if (form) form.submit();
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { rootMargin: '0px 0px -10% 0px' });
      observer.observe(pdpAddBtn);
    }
  }


  /* ---------------------------------------------------------------------
     Mobile nav toggle
     ------------------------------------------------------------------- */
    /* ---------------------------------------------------------------------
     Close mega-menu / search dropdowns when clicking outside
     ------------------------------------------------------------------- */
  document.addEventListener('click', function (event) {
    document.querySelectorAll('.site-nav details[open], .site-search[open]').forEach(function (el) {
      if (!el.contains(event.target)) el.removeAttribute('open');
    });
  });

  /* ---------------------------------------------------------------------
     Mobile nav toggle
     ------------------------------------------------------------------- */
  var navToggle = document.querySelector('[data-nav-toggle]');
  var siteNav = document.querySelector('[data-site-nav]');
  if (navToggle && siteNav) {
    navToggle.addEventListener('click', function () {
      var isOpen = siteNav.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  /* ---------------------------------------------------------------------
     Collection filter pills (filters by data-tag on product cards)
     ------------------------------------------------------------------- */
  var filterWrap = document.querySelector('[data-collection-filters]');
  if (filterWrap) {
    var pills = filterWrap.querySelectorAll('[data-filter-value]');
    var cards = document.querySelectorAll('[data-product-card]');
    var countEl = document.querySelector('[data-collection-count]');

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
        pill.setAttribute('aria-pressed', 'true');

        var value = pill.getAttribute('data-filter-value');
        var visibleCount = 0;

        cards.forEach(function (card) {
          var tags = (card.getAttribute('data-tags') || '').split(',');
          var show = value === 'all' || tags.indexOf(value) !== -1;
          card.style.display = show ? '' : 'none';
          if (show) visibleCount++;
        });

        if (countEl) {
          countEl.textContent = visibleCount + (visibleCount === 1 ? ' produkt' : ' produkter');
        }
      });
    });
  }

  /* ---------------------------------------------------------------------
     Quantity steppers on product cards
     ------------------------------------------------------------------- */
  document.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
    var input = stepper.querySelector('[data-qty-input]');
    stepper.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-qty-step'), 10);
        var current = parseInt(input.value, 10) || 1;
        var next = Math.max(1, current + step);
        input.value = next;
      });
    });
  });

});



document.addEventListener('DOMContentLoaded', function () {
  /* ---------------------------------------------------------------------
     Cart page: remove line item
     ------------------------------------------------------------------- */
  document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var row = btn.closest('[data-cart-row]');
      var input = row && row.querySelector('[data-qty-input]');
      if (input) {
        input.value = 0;
        var form = document.getElementById('CartForm');
        if (form && form.requestSubmit) form.requestSubmit();
        else if (form) form.submit();
      }
    });
  });
});


document.addEventListener('DOMContentLoaded', function () {
  /* ---------------------------------------------------------------------
     Email subscription popup
     ------------------------------------------------------------------- */
  var popup = document.querySelector('[data-email-popup]');
  if (popup) {
    var storageKey = 'sm_email_popup_dismissed';
    var alreadyDismissed = false;
    try { alreadyDismissed = window.localStorage.getItem(storageKey) === 'yes'; } catch (e) {}

    var wasSuccessful = !!popup.querySelector('[data-email-popup-success]');

    if (wasSuccessful) {
      // Form just posted successfully on page reload — keep it open and remember.
      popup.removeAttribute('hidden');
      try { window.localStorage.setItem(storageKey, 'yes'); } catch (e) {}
    } else if (!alreadyDismissed) {
      window.setTimeout(function () {
        popup.removeAttribute('hidden');
      }, 1500);
    }

    popup.querySelectorAll('[data-email-popup-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        popup.setAttribute('hidden', '');
        try { window.localStorage.setItem(storageKey, 'yes'); } catch (e) {}
      });
    });

    var copyBtn = popup.querySelector('[data-copy-code]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = copyBtn.getAttribute('data-copy-code');
        if (navigator.clipboard) {
          navigator.clipboard.writeText(code).then(function () {
            var original = copyBtn.textContent;
            copyBtn.textContent = 'Kopieret!';
            window.setTimeout(function () { copyBtn.textContent = original; }, 2000);
          });
        }
      });
    }
  }

  /* ---------------------------------------------------------------------
     Cart page: discount code box redirects through /discount/ then back
     ------------------------------------------------------------------- */
  var discountForm = document.querySelector('[data-cart-discount-form]');
  if (discountForm) {
    discountForm.addEventListener('submit', function (event) {
      event.preventDefault();
      var input = discountForm.querySelector('[data-cart-discount-input]');
      var code = input && input.value.trim();
      if (code) {
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart';
      }
    });
  }
});


document.addEventListener('DOMContentLoaded', function () {
  /* ---------------------------------------------------------------------
     Predictive search: live product suggestions while typing
     ------------------------------------------------------------------- */
  var searchInput = document.querySelector('[data-predictive-search-input]');
  var searchResults = document.querySelector('[data-predictive-search-results]');
  var searchDetails = document.querySelector('[data-site-search]');

  if (searchInput && searchResults) {
    var debounceTimer;

    function clearResults() {
      searchResults.innerHTML = '';
      searchResults.setAttribute('hidden', '');
    }

    searchInput.addEventListener('input', function () {
      var query = searchInput.value.trim();
      clearTimeout(debounceTimer);

      if (query.length < 2) {
        clearResults();
        return;
      }

      debounceTimer = setTimeout(function () {
               fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,collection&resources[limit]=5&resources[limit_scope]=each&resources[options][unavailable_products]=last')
          .then(function (response) { return response.json(); })
          .then(function (data) {
            var results = (data.resources && data.resources.results) || {};
            var products = results.products || [];
            var collections = results.collections || [];

            if (products.length === 0 && collections.length === 0) {
              searchResults.innerHTML = '<p class="site-search__empty">Ingen resultater fundet.</p>';
              searchResults.removeAttribute('hidden');
              return;
            }

            var html = '';

            if (collections.length > 0) {
              html += '<p class="site-search__group-label">Kategorier</p>';
              html += collections.map(function (collection) {
                return '<a href="' + collection.url + '" class="site-search__result site-search__result--collection">' +
                  '<span class="site-search__result-title">' + collection.title + '</span>' +
                '</a>';
              }).join('');
            }

            if (products.length > 0) {
              if (collections.length > 0) html += '<p class="site-search__group-label">Produkter</p>';
              html += products.map(function (product) {
                var imageUrl = '';
                if (product.featured_image) {
                  imageUrl = product.featured_image.url || product.featured_image;
                } else if (product.image) {
                  imageUrl = product.image;
                }
                var imageTag = imageUrl ? '<img src="' + imageUrl + '" alt="" width="44" height="44" loading="lazy">' : '';

                return '<a href="' + product.url + '" class="site-search__result">' +
                  '<span class="site-search__result-media">' + imageTag + '</span>' +
                  '<span class="site-search__result-info">' +
                    '<span class="site-search__result-title">' + product.title + '</span>' +
                    '<span class="site-search__result-price">' + product.price + '</span>' +
                  '</span>' +
                '</a>';
              }).join('');
            }

            html += '<a href="/search?q=' + encodeURIComponent(query) + '&type=product,collection" class="site-search__see-all">Se alle resultater</a>';

            searchResults.innerHTML = html;
            searchResults.removeAttribute('hidden');
          })
          .catch(function () {
            clearResults();
          });
      }, 250);
    });

    if (searchDetails) {
      searchDetails.addEventListener('toggle', function () {
        if (!searchDetails.open) {
          searchInput.value = '';
          clearResults();
        }
      });
    }
  }
});